import React, { useEffect, useRef, useState } from "react";
import { DropdownStatusList, EmptyString, FormTypeEdit, InsertDateFormat } from "utils/Constant";
import { addSpaceEvery4, GetPaymentStatus, GetStatus, money } from "utils/helpers";
import moment from "moment";
import DatePicker from "components/Input/DatePicker";
import Dropdown from "components/Input/Dropdown";
import CheckCircleIcon from "assets/icon/CheckCircleIcon";
import XIcon from "assets/icon/XIcon";
import Select from 'react-select'
import ChevronDownIcon from "assets/icon/ChevronDownIcon";
import ChevronUpIcon from "assets/icon/ChevronUpIcon";
import RevisionIcon from "assets/icon/RevisionIcon";
import CopyIcon from "assets/icon/CopyIcon";
import TransferFormModal from "./TransferFormModal";
import ShowIcon from "assets/icon/ShowIcon";
import notificationSound from 'sounds/notification_sound.mp3';
import * as signalR from "@microsoft/signalr";
import { useModal } from "utils/context/ModalContext";
import { useCallApi } from "api/apiHooks";
import { FilterCard, GridEditButton, GridViewButton, MainBodyCard, PagesTitle } from "components/Cards";
import { BankBalanceService } from "services/BankBalanceService/BankBalanceService";
import { TransactionService } from "services/TransactionService/TransactionService";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "components/Button/PrimaryButton";
import { useVariable } from "utils/context/VariableContext";

export const API_BASE_URL = process.env.REACT_APP_API_URL

export default function Transfer(){
    const navigate = useNavigate()

    const { isAdmin, transferSourceOptions, locationOptions } = useVariable()

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchCashIn, fetchTransferPL } = useCallApi()
    const { fetchCustomerPaymentList, fetchProceedPayment, fetchCustomerPaymentSummary } = TransactionService()
    const { fetchBankBalance, fetchUpdateBankBalance } = BankBalanceService()

    const debounceRef = useRef(null)

    const [status, setStatus] = useState(DropdownStatusList[1].value)
    const [transactionDate, setTransactionDate] = useState(new Date())    
    const [customerPaymentListOnProcess, setCustomerPaymentListOnProcess] = useState([])
    const [customerPaymentListPaidTransfer, setCustomerPaymentListPaidTransfer] = useState([])
    const [customerPaidTransfer, setCustomerPaidTransfer] = useState([])
    const [customerPaymentListCash, setCustomerPaymentListCash] = useState([])
    const [customerCash, setCustomerCash] = useState([])
    const [showCash, setShowCash] = useState(false)
    const [showPaidTransfer, setShowPaidTransfer] = useState(false)
    const [showSummary, setShowSummary] = useState(false)
    const [totalTransferAmount, setTotalTransferAmount] = useState(0)
    const [totalCashAmount, setTotalCashAmount] = useState(0)
    const [totalTransferAnjasmoro, setTotalTransferAnjasmoro] = useState(0)
    const [totalTransferTlogosari, setTotalTransferTlogosari] = useState(0)
    const [totalCashAnjasmoro, setTotalCashAnjasmoro] = useState(0)
    const [totalCashTlogosari, setTotalCashTlogosari] = useState(0)
    const [transferDetailList, setTransferDetailList] = useState([])
    const [groupTransferSource, setGroupTransferSource] = useState({})
    const [balanceList, setBalanceList] = useState([])
    const [isEditBalanceModalOpen, setIsEditBalanceModalOpen] = useState(false)
    const [selectedBalance, setSelectedBalance] = useState({})
    const [onIncreaseBalance, setOnIncreaseBalance] = useState('')
    const [onUpdateBalance, setOnUpdateBalance] = useState('')
    const [onDecreaseBalance, setOnDecreaseBalance] = useState('')
    const [bankBalanceFilterAccountName, setBankBalanceFilterAccountName] = useState('')
    const [primaryBankBalance, setPrimaryBankBalance] = useState(JSON.parse(localStorage.getItem('PrimaryBankBalance')) || [])
    const [showBalance, setShowBalance] = useState(false)

    const [paidTransferCustomerNameFilter, setPaidTransferCustomerNameFilter] = useState("")
    const [paidTransferBeneficiaryNameFilter, setPaidTransferBeneficiaryNameFilter] = useState("")
    const [paidTransferLocationIdFilter, setPaidTransferLocationIdFilter] = useState("")
    const [paidTransferStatusFilter, setPaidTransferStatusFilter] = useState("1") // 1 = Active
    const [cashCustomerNameFilter, setCashCustomerNameFilter] = useState("")
    const [cashLocationFilterOptions, setCashLocationFilterOptions] = useState(locationOptions)
    const [cashLocationIdFilter, setCashLocationIdFilter] = useState("")
    const [cashStatusFilter, setCashStatusFilter] = useState("1") // 1 = Active
    const [totalCashInAmount, setTotalCashInAmount] = useState("0")
    const [totalTransferPLAmount, setTotalTransferPLAmount] = useState("0")
    const groupedWithSubtotal = React.useMemo(() => {
        if (!Array.isArray(customerPaymentListOnProcess)) return [];

        const grouped = customerPaymentListOnProcess.reduce((acc, item) => {
            const accNumber = item.accountNumber?.replace(/\s+/g, "");

            if (!acc[accNumber]) {
                acc[accNumber] = {
                    accountNumber: accNumber,
                    totalAmount: 0,
                    rows: []
                };
            }

            acc[accNumber].totalAmount += parseFloat(item.amount);
            acc[accNumber].rows.push(item);

            return acc;
        }, {});

        return Object.values(grouped);
    }, [customerPaymentListOnProcess])
    const [transferFormModal, setTransferFormModal] = useState({ isOpen: false, customerPaymentId: 0, formType: FormTypeEdit, data: {} })
    const [unpaidTransferView, setUnpaidTransferView] = useState('1')

    const handleGroupTransferChange = (accountNumber, selectedOption) => {
        setGroupTransferSource(prev => ({
            ...prev,
            [accountNumber]: selectedOption?.value || ""
        }));
    }
    const transferFormModalClose = () => {
        setTransferFormModal({ isOpen: false, customerPaymentId: 0 })
        showLoading()

        fetchCustomerPaymentList(transactionDate, '2', '', '1').then((res) => {
            if (!res) return

            setCustomerPaymentListPaidTransfer(res.data)
            setCustomerPaidTransfer(res.data)
            hideLoading()
        })
    }

    // Use Web Socket (SignalR) to listen for new transactions
    useEffect(() => {
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(API_BASE_URL + "/transactionHub/")
            .withAutomaticReconnect()
            .build();

        try {
            showLoading()

            fetchCustomerPaymentList(moment(transactionDate).format("yyyy-MM-DD"), '1', '1', '1').then((res) => {
                if (!res) return

                setCustomerPaymentListOnProcess(res.data)
            })

            fetchBankBalance().then((res) => {
                if (!res) return

                setBalanceList(res.data)
            })

            connection.start()
                .then(() => console.log("Connected to Transaction Hub"))
                .catch(err => console.error("Connection error:", err));

            connection.on("NewTransaction", (txn) => {
                fetchCustomerPaymentList(moment(transactionDate).format("yyyy-MM-DD"), '1', '1', '1').then((res) => {
                    if (!res) return

                    setCustomerPaymentListOnProcess(res.data)
                    let data = res.data
                    if (data !== null && data.length > 0){
                        playNotificationSound()
                    }
                })
            });
        } finally {
            hideLoading()
        }
        
        return () => {
            connection.stop();
        }
    }, [])

    useEffect(() => {
        if(showCash){
            showLoading()

            fetchCustomerPaymentList(transactionDate, '2', '', '2').then((res) => {
                if (!res) return

                setCustomerPaymentListCash(res.data)
                setCustomerCash(res.data)
                hideLoading()
            })
        }
    },[showCash])

    useEffect(() => {
        const onLoad = async () => {
            showLoading()

            try {
                const res = await fetchCustomerPaymentList(transactionDate, '2', '', '1')
                if (!res) return

                setCustomerPaymentListPaidTransfer(res.data)
                setCustomerPaidTransfer(res.data)
            }
            finally {
                hideLoading()
            }
        }
        
        if(!showPaidTransfer) return 

        onLoad()
    },[showPaidTransfer])

    useEffect(() => {
        if(showSummary){
            getCustomerPaymentSummary()
        }
    },[showSummary])

    const getCustomerPaymentSummary = async () => {
        showLoading()

        try {
            fetchCustomerPaymentSummary(moment(transactionDate).format(InsertDateFormat)).then((res) => {
                if (!res) return

                let data = res.data

                setTotalTransferAmount(data.totalTransfer)
                setTotalCashAmount(data.totalCash)
                setTotalTransferAnjasmoro(data.totalTransferAnjasmoro)
                setTotalTransferTlogosari(data.totalTransferTlogosari)
                setTotalCashAnjasmoro(data.totalCashAnjasmoro)
                setTotalCashTlogosari(data.totalCashTlogosari)
                setTransferDetailList(data.transferDetail)

                fetchCashIn(moment(transactionDate).format(InsertDateFormat)).then((res) => {
                    if (!res) return

                    let data = res.data
                    setTotalCashInAmount(data?.length > 0 ? money(data?.reduce((sum, record) => sum + parseFloat(record.amount), 0)) : 0)

                    fetchTransferPL(moment(transactionDate).format(InsertDateFormat), '', '1').then((res) => {
                        let data = res.data

                        setTotalTransferPLAmount(data?.length > 0 ? money(data?.reduce((sum, record) => sum + parseFloat(record.amount), 0)) : 0)
                    })
                })
            })
        } finally {
            hideLoading()
        }
    }
    
    const handleRoleChange = (id, selectedOption) => {
        setCustomerPaymentListOnProcess((prevRows) =>
            Array.isArray(prevRows)
                ? prevRows.map((row) => row.customerPaymentId === id ? { ...row, transferSourceId: selectedOption.value } // ✅ correct property
                        : row
                )
                : []
        );
    }
    const handleRowButtonClick = (i, key, id, amount) => {
        const row = customerPaymentListOnProcess.find(r => r.customerPaymentId === i);
        if (!row) return;

        const selected = transferSourceOptions.find(
            (opt) => opt.value === row.transferSourceId
        );

        if (selected !== null && typeof selected !== 'undefined') {
            if (selected.value === null || selected.value === EmptyString || typeof selected.value === 'undefined') {
                showFail("Please select a transfer source before proceeding.")
                return
            } else {
                showLoading()

                try {
                    let data = [
                        {
                            customerPaymentId: id, 
                            transferSourceId: selected.value,
                            amount: amount
                        }
                    ]

                    fetchProceedPayment(data).then((res) => {
                        if (!res) return

                        fetchCustomerPaymentList(moment(transactionDate).format("yyyy-MM-DD"), '1', '1', '1').then((res) => {
                            if (!res) return

                            setCustomerPaymentListOnProcess(res.data)
                        })
                    })
                } finally {
                    hideLoading()
                }
            }
        } else {
            showFail("Please select a transfer source before proceeding.")
            return
        }
        
    }
    const handleGroupProcess = async (list, transferSourceId) => {
        if (!Array.isArray(list) || list.length === 0) return

        const onConfirm = await confirm("Process all transactions for this account?")
        
        if (onConfirm) {
            showLoading()

            try {
                let data = []

                list.map(item =>
                    data.push({customerPaymentId: item.customerPaymentId, transferSourceId: transferSourceId, amount: item.amount})
                )

                fetchProceedPayment(data).then(() => {
                    fetchCustomerPaymentList(
                        moment(transactionDate).format("yyyy-MM-DD"),
                        '1', '1', '1'
                    ).then((res) => {
                        if (!res) return;
                        setCustomerPaymentListOnProcess(res.data)

                        fetchBankBalance().then((res) => {
                            if (!res) return

                            setBalanceList(res.data)
                        })
                    })
                })
            } finally {
                hideLoading();
            }
        }
    }
    const handleCopyBtnClick = (text) => {
        navigator.clipboard.writeText(text)
    }
    const playNotificationSound = () => {
        const audio = new Audio(notificationSound);
        audio.play();
    }
    const handleUpdateIncreaseBalance = async(transferSourceId, beneficiaryId, bankBalanceId, balance, increaseBalance) => {
        showLoading()

        try {
            const bal = parseFloat(String(balance).replaceAll(',', '')) + parseFloat(String(increaseBalance).replaceAll(',', ''))

            const res = await fetchUpdateBankBalance(transferSourceId, beneficiaryId, bankBalanceId, bal)
            if (!res) return

            await fetchBankBalance().then((res) => {
                if (!res) return

                setBalanceList(res.data)
            })

            setSelectedBalance(prev => ({
                ...prev,
                balance: bal
            }))

            setOnIncreaseBalance('')

            if (bankBalanceId === 0) {
                setIsEditBalanceModalOpen(false)
            }
        } finally {
            hideLoading()
        }
    }
    const handleUpdateDecreaseBalance = async(transferSourceId, beneficiaryId, bankBalanceId, balance, decreaseBalance) => {
        showLoading()

        try {
            const bal = parseFloat(String(balance).replaceAll(',', '')) - parseFloat(String(decreaseBalance).replaceAll(',', ''))

            const res = await fetchUpdateBankBalance(transferSourceId, beneficiaryId, bankBalanceId, bal)
            if (!res) return

            await fetchBankBalance().then((res) => {
                if (!res) return

                setBalanceList(res.data)
            })

            setSelectedBalance(prev => ({
                ...prev,
                balance: bal
            }))

            setOnDecreaseBalance('')

            if (bankBalanceId === 0) {
                setIsEditBalanceModalOpen(false)
            }
        } finally {
            hideLoading()
        }
    }

    // Event Change
    useEffect(() => {
        const filteredData = customerPaidTransfer.filter(item => {
            // --- Normalize search inputs ---
            const nameSearch = (paidTransferCustomerNameFilter || "").toLowerCase().trim();
            const beneficiarySearch = (paidTransferBeneficiaryNameFilter || "").toLowerCase().trim();
            const locationSearch = (paidTransferLocationIdFilter?.label || "").toLowerCase();
            const statusSearch = (paidTransferStatusFilter || "").toLowerCase();

            // --- Normalize item fields (avoid undefined/null errors) ---
            const customerName = (item.customerName || "").toLowerCase();
            const accountName = (item.accountName || "").toLowerCase();
            const locationName = (item.locationName || "").toLowerCase();
            const statusName = (item.status || "").toLowerCase(); // adjust key if different

            // --- Matching logic ---
            const matchesName = nameSearch
                ? customerName.includes(nameSearch)
                : true;

            const matchesBeneficiary = beneficiarySearch
                ? accountName.includes(beneficiarySearch)
                : true;

            const matchesLocation = locationSearch
                ? locationName === locationSearch
                : true;

            const matchesStatus = statusSearch
                ? statusName === statusSearch
                : true;

            // If no name/beneficiary search, don't filter by them
            const hasSearch = nameSearch || beneficiarySearch;

            return (
                matchesName &&
                matchesBeneficiary &&
                matchesLocation &&
                matchesStatus
            );
        });

        setCustomerPaymentListPaidTransfer(filteredData);
    }, [
        customerPaidTransfer,
        paidTransferCustomerNameFilter,
        paidTransferBeneficiaryNameFilter,
        paidTransferLocationIdFilter,
        paidTransferStatusFilter
    ])

    const handleCashClearFilterClick = () => {
        setCashCustomerNameFilter("")
        setCashLocationIdFilter("")
        setCustomerPaymentListCash(customerCash)
        setCashStatusFilter("1")
    }
    const handleCashCustomerNameFilterChange = (e) => {
        setCashCustomerNameFilter(e.target.value);

        const filteredData = customerCash.filter(item =>
            item.customerName.toLowerCase().includes(e.target.value.toLowerCase())
        );
        setCustomerPaymentListCash(filteredData);
    }
    const handleCashLocationIdFilterChange = (e) => {
        setCashLocationIdFilter(e.value);

        const filteredData = customerCash.filter(item =>
            item.locationName.toLowerCase() === e.label.toLowerCase()
        );
        setCustomerPaymentListCash(filteredData);        
    }
    const handleCashStatusFilterChange = (e) => {
        setCashStatusFilter(e.value);

        if (e.value === EmptyString){
            setCustomerPaymentListCash(customerCash);
        }
        else {
            const filteredData = customerCash.filter(item =>
                item.status === e.value
            );
            setCustomerPaymentListCash(filteredData);
        }        
    }

    return(
        <MainBodyCard>
            <PagesTitle title='Transfer' />

            {isAdmin && (
                <div className="hidden sm:grid sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-5 2xl:grid-cols-6 3xl:grid-cols-6 gap-2">
                    {balanceList?.filter(item => primaryBankBalance.includes(String(item.transferSourceId))).map((data, i) => {
                        return (
                            <div 
                                className="flex items-center bg-white rounded-lg shadow-md min-w-56 p-2 border" key={i}
                                onClick={() => { 
                                    setSelectedBalance(data)
                                    setIsEditBalanceModalOpen(true) 
                                }}
                            >
                                <div className="flex flex-col">
                                    <div>
                                        <span className="text-sm">
                                            { data.bankCode } - {data.accountName.length > 16 
                                                ? data.accountName.slice(0, 16).toUpperCase() + "..." 
                                                : data.accountName.toUpperCase()
                                            }
                                        </span>
                                    </div>
                                    <div>
                                        <span className="text-xs font-light">{ data.accountNo }</span>
                                    </div>
                                    <div>
                                        <span className="text-base font-semibold">Rp { money(data.balance) }</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            )}
            
            <div className="sm:mt-2"> 
                {/* Filter */}
                <div className="flex justify-between">
                    <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
                        <FilterCard title='Tanggal Transaksi' width='w-full sm:w-56'>
                            <DatePicker className="w-full h-10 bg-white" value={transactionDate} onChange={setTransactionDate} />
                        </FilterCard>

                        <FilterCard title='Status'>
                            <Dropdown className="w-full sm:w-32"
                                value={status} 
                                options={DropdownStatusList} 
                                onChange={(e) => { setStatus(e.value) }} 
                                placeholder="All"
                            />
                        </FilterCard>
                    </div>
                    
                    <div className="flex gap-3 justify-end">
                        <FilterCard title='' width='w-auto'>
                            <PrimaryButton title='Riwayat Tunai' onClick={() => navigate('/transfer/cash-history')} />
                        </FilterCard>

                        <FilterCard title='' width='w-auto'>
                            <PrimaryButton title='Riwayat Transfer' onClick={() => navigate('/transfer/transfer-history')} />
                        </FilterCard>
                    </div>
                </div>        

                {/* Unpaid Transfer */}
                <div className="sm:mt-4 w-full">
                    <div className="mt-5 sm:bg-white sm:p-3 rounded sm:shadow-md w-full">
                        <div className="flex gap-2 items-center justify-between">
                            <div className="flex gap-4">
                                <span className="font-semibold text-xl">Belum Transfer</span>
                                <div className="bg-white rounded-full p-1 border hidden sm:flex gap-4">
                                    <button 
                                        className={`px-3 py-1 text-sm rounded-full ${unpaidTransferView === '1' ? 'bg-black text-white' : ''} `}
                                        onClick={() => setUnpaidTransferView('1')}    
                                    >
                                        Group By Account
                                    </button>
                                    <button
                                        className={`px-3 py-1 text-sm rounded-full ${unpaidTransferView === '2' ? 'bg-black text-white' : ''} `}
                                        onClick={() => setUnpaidTransferView('2')}    
                                    >
                                        Per Transaction
                                    </button>
                                </div>
                            </div>
                            
                            <button className="bg-black text-white px-3 py-1 rounded-full flex items-center gap-2"
                                onClick={() => {
                                    fetchCustomerPaymentList(moment(transactionDate).format("yyyy-MM-DD"), '1', '1', '1').then((res) => {
                                        if (!res) return

                                        setCustomerPaymentListOnProcess(res.data)
                                    })
                                }}
                            >
                                <span className="text-xs">Refresh</span>
                            </button>
                        </div>

                        { unpaidTransferView === '1' ? 
                            <div className="w-full">
                                <table className="w-full hidden sm:table border bg-white mt-4 text-sm xl:text-base">
                                    <thead>
                                        <tr className="h-12 w-full">
                                            <th className="font-semibold w-16">No</th>
                                            <th className="font-semibold text-left px-2">Customer Name</th>
                                            <th className="font-semibold text-left px-2">Bank</th>
                                            <th className="font-semibold text-left px-2">Account Name</th>
                                            <th className="font-semibold text-left px-2">Account No</th>
                                            <th className="font-semibold text-left px-2">Amount</th>
                                            <th className="font-semibold text-left px-2">Remark</th>
                                            <th className="font-semibold text-left px-2">Location</th>
                                            <th className="font-semibold text-left px-2 hidden">Payment Status</th>
                                        </tr>
                                    </thead>
                                    <tbody className="border">
                                        {groupedWithSubtotal.length === 0 && 
                                            <tr className="h-10 border-y">
                                                <td colSpan={11} className="text-center">No Data Available</td>
                                            </tr>
                                        }
                                        {groupedWithSubtotal.map((group, groupIndex) => (
                                            <React.Fragment key={groupIndex}>
                                                {/* 🔹 ORIGINAL ROWS */}
                                                {group.rows.map((data, i) => (
                                                    <tr className="my-2 row h-8 border-y hover:bg-slate-300" key={data.customerPaymentId}>
                                                        <td className="text-center">{ data.rowNumber }</td>

                                                        <td className="px-2">
                                                            <span>
                                                                {data.customerName.length > 16 
                                                                    ? data.customerName.slice(0, 16).toUpperCase() + "..." 
                                                                    : data.customerName.toUpperCase()}
                                                            </span>
                                                        </td>

                                                        <td className="px-2">
                                                            <span>{ data.bankCode }</span>
                                                        </td>

                                                        <td className="px-2">
                                                            <span>
                                                                {data.accountName.length > 16 
                                                                    ? data.accountName.slice(0, 16).toUpperCase() + "..." 
                                                                    : data.accountName.toUpperCase()}
                                                            </span>
                                                        </td>

                                                        <td className="px-2 text-nowrap">
                                                            <button onClick={() => { handleCopyBtnClick(data.accountNumber) }}>
                                                                <span>{ addSpaceEvery4(data.accountNumber) }</span>
                                                            </button>
                                                        </td>

                                                        <td className="px-2 text-nowrap">
                                                            <span>Rp { money(data.amount) }</span>
                                                        </td>

                                                        <td className="px-2">
                                                            <span>{ data.remark }</span>
                                                        </td>

                                                        <td>
                                                            <span>{ data.locationName.toUpperCase() }</span>
                                                        </td>

                                                        <td className="px-2 hidden">
                                                            <span>{ GetPaymentStatus(data.paymentStatus) }</span>
                                                        </td>
                                                    </tr>
                                                ))}

                                                <tr className="bg-gray-100 font-semibold border-y h-12">
                                                    <td colSpan={5} className="text-right px-2">
                                                        Subtotal ({ addSpaceEvery4(group.accountNumber) })
                                                    </td>

                                                    <td className="px-2 text-nowrap text-blue-600">
                                                        Rp { money(group.totalAmount) }
                                                    </td>

                                                    {/* 🔽 GROUP DROPDOWN */}
                                                    <td className="px-2 w-64">
                                                        <Select
                                                            value={
                                                                transferSourceOptions.find(
                                                                    opt => opt.value === groupTransferSource[group.accountNumber]
                                                                ) || null
                                                            }
                                                            options={transferSourceOptions}
                                                            onChange={(option) =>
                                                                handleGroupTransferChange(group.accountNumber, option)
                                                            }
                                                        />
                                                    </td>

                                                    {/* 🔘 PROCESS BUTTON */}
                                                    <td colSpan={4} className="px-2">
                                                        <button
                                                            className="bg-black px-3 py-1 text-white rounded-full text-sm flex items-center gap-2"
                                                            onClick={() => {
                                                                const selectedSource = groupTransferSource[group.accountNumber];

                                                                if (!selectedSource) {
                                                                    showFail("Please select transfer source first.");
                                                                    return;
                                                                }

                                                                handleGroupProcess(
                                                                    group.rows,
                                                                    selectedSource
                                                                );
                                                            }}
                                                        >
                                                            Process All ({group.rows.length})
                                                        </button>
                                                    </td>
                                                </tr>

                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            :
                            <div className="w-full">
                                <table className="w-full hidden sm:table border bg-white mt-4 text-sm xl:text-base">
                                    <thead>
                                        <tr className="h-12 w-full">
                                            <th className="font-semibold w-16">No</th>
                                            <th className="font-semibold text-left px-2">Customer Name</th>
                                            <th className="font-semibold text-left px-2">Bank</th>
                                            <th className="font-semibold text-left px-2">Account Name</th>
                                            <th className="font-semibold text-left px-2">Account No</th>
                                            <th className="font-semibold text-left px-2">Amount</th>
                                            <th className="font-semibold text-left px-2">Remark</th>
                                            <th className="font-semibold text-left px-2">Location</th>
                                            <th className="font-semibold text-left px-2 hidden">Payment Status</th>
                                            <th className="font-semibold text-left px-2">Transfer Source</th>
                                            <th className="font-semibold sm:w-24">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className="border">
                                        {customerPaymentListOnProcess.length === 0 && 
                                            <tr className="my-2 row h-10 border-y hover:bg-slate-300">
                                                <td colSpan={11} className="text-center">No Data Available</td>
                                            </tr>
                                        }
                                        {customerPaymentListOnProcess?.map((data, i) => {
                                            return(
                                                <tr className="my-2 row h-10 border-y hover:bg-slate-300" key={ i }>
                                                    <td className="text-center">{ data.rowNumber }</td>
                                                    <td className="px-2">
                                                        <span>{ (data.customerName.length > 16 ? data.customerName.slice(0, 16).toUpperCase() + "..." : data.customerName.toUpperCase()) }</span>
                                                    </td>
                                                    <td className="px-2">
                                                        <span>{ data.bankCode }</span>
                                                    </td>
                                                    <td className="px-2">
                                                        <span>{ (data.accountName.length > 16 ? data.accountName.slice(0, 16).toUpperCase() + "..." : data.accountName.toUpperCase()) }</span>
                                                        
                                                    </td>
                                                    <td className="px-2 text-nowrap">
                                                        <span>{ addSpaceEvery4(data.accountNumber) }</span>
                                                        <button
                                                            onClick={() => handleCopyBtnClick(data.accountNumber)}
                                                        >
                                                            <CopyIcon className="w-4 h-4 ml-2 cursor-pointer hover:opacity-70" />
                                                        </button>
                                                    </td>
                                                    <td className="px-2 text-nowrap">
                                                        <span>Rp { money(data.amount) }</span>
                                                    </td>
                                                    <td className="px-2">
                                                        <span>{ data.remark }</span>
                                                    </td>
                                                    <td className="">
                                                        <span>{ data.locationName.toUpperCase() }</span>
                                                    </td>
                                                    <td className="px-2 hidden">
                                                        <span>{ GetPaymentStatus(data.paymentStatus) }</span>
                                                    </td>
                                                    <td className="px-2 table-cell w-72">
                                                        <Select
                                                            value={String(data.transferSourceId) !== "0" ? transferSourceOptions.find(opt => opt.value === String(data.transferSourceId)) : null}
                                                            options={transferSourceOptions}
                                                            onChange={option => handleRoleChange(data.customerPaymentId, option)}
                                                            isDisabled={data.paymentStatus === '2'}
                                                        />
                                                    </td>
                                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                                        <button className={`button flex gap-2 ${ data.paymentStatus === '2' ? 'hidden' : '' }`} 
                                                            onClick={() => handleRowButtonClick(data.customerPaymentId, 'transferSource', data.customerPaymentId, data.amount)}
                                                        >
                                                            <CheckCircleIcon className="w-4 fill-white" />
                                                        </button>
                                                        <button className={`button flex gap-2 ${ data.paymentStatus === '2' ? 'hidden' : '' }`} 
                                                            onClick={() => setTransferFormModal({ isOpen: true, customerPaymentId: data.customerPaymentId, formType: "View" }) }
                                                        >
                                                            <ShowIcon className="w-4 fill-white" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                    <tfoot>
                                        <tr className="h-12">
                                            <th colSpan={5} className="font-semibold text-right px-2">Total</th>
                                            <th className="font-semibold text-left px-2 text-nowrap">Rp { money(customerPaymentListOnProcess.reduce((total, item) => total + item.amount, 0)) }</th>
                                            <th colSpan={5}></th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        }   
                        
                        {/* Mobile Version */}
                        <div className="sm:hidden">
                            {customerPaymentListOnProcess.length === 0 && 
                                <div className="my-2 h-10 border-y hover:bg-slate-300 flex items-center justify-center">
                                    <span className="text-center">No Data Available</span>
                                </div>
                            }
                            {customerPaymentListOnProcess.length > 0 && 
                                <div className="my-2 py-2 px-3 mb-5 border rounded-xl bg-gray-100 hover:bg-slate-300 flex justify-between items-center opacity-50">
                                    <div className="flex flex-col">
                                        <span className="text-xs">Total</span>
                                        <span className="font-semibold">Rp { money(customerPaymentListOnProcess.reduce((total, item) => total + item.amount, 0)) }</span>
                                    </div>
                                    <div className="flex bg-black rounded-full px-3 py-1">
                                        <span className="text-xs text-white">{customerPaymentListOnProcess.length} trx</span>
                                    </div>
                                </div>
                            }
                            {groupedWithSubtotal.map((group, groupIndex) => (
                                <React.Fragment key={groupIndex}>
                                    {/* 🔹 ORIGINAL ROWS */}
                                    {group.rows.map((data, i) => (
                                        <div className="border-y hover:bg-slate-300 text-sm py-2" key={data.customerPaymentId}>
                                            <div className="flex">
                                                <span className="font-semibold">
                                                    {data.customerName.length > 16 
                                                        ? data.customerName.slice(0, 16).toUpperCase() + "..." 
                                                        : data.customerName.toUpperCase()}
                                                </span>
                                            </div>

                                            <div className="flex justify-between">
                                                <span>{ data.bankName.toUpperCase() }</span>
                                                <span>{ data.locationName.toUpperCase() }</span>
                                            </div>

                                            <div className="flex justify-between">
                                                <span>
                                                    {data.accountName.length > 16 
                                                        ? data.accountName.slice(0, 16).toUpperCase() + "..." 
                                                        : data.accountName.toUpperCase()}
                                                </span>
                                                <button onClick={() => { handleCopyBtnClick(data.accountNumber) }}>
                                                    <span>{ addSpaceEvery4(data.accountNumber) }</span>
                                                </button>
                                            </div>

                                            <div className="flex justify-center font-semibold text-base">
                                                <span>Rp { money(data.amount) }</span>
                                            </div>

                                            <div className="flex">
                                                <span>{ data.remark }</span>
                                            </div>
                                        </div>
                                    ))}

                                    <div className="bg-gray-100 font-semibold border-y text-base mb-4 py-2 px-2">
                                        <div className="flex justify-between pb-2">
                                            <button onClick={() => { handleCopyBtnClick(group.accountNumber) }}>
                                                <span>Subtotal ({ addSpaceEvery4(group.accountNumber) })</span>
                                            </button>
                                            <span className="">Rp { money(group.totalAmount) }</span>
                                        </div>

                                        {/* 🔽 GROUP DROPDOWN */}
                                        <div className="flex w-full text-base">
                                            <Select
                                                value={
                                                    transferSourceOptions.find(
                                                        opt => opt.value === groupTransferSource[group.accountNumber]
                                                    ) || null
                                                }
                                                options={transferSourceOptions}
                                                onChange={(option) =>
                                                    handleGroupTransferChange(group.accountNumber, option)
                                                }
                                                className="w-full"
                                            />
                                        </div>
                                        <div className="flex w-full mt-2">
                                            <button
                                                className="bg-black px-3 py-2 text-white rounded-full text-sm items-center w-full"
                                                onClick={() => {
                                                    const selectedSource = groupTransferSource[group.accountNumber];

                                                    if (!selectedSource) {
                                                        showFail("Please select transfer source first.");
                                                        return;
                                                    }

                                                    handleGroupProcess(
                                                        group.rows,
                                                        selectedSource
                                                    );
                                                }}
                                            >
                                                Process All ({group.rows.length})
                                            </button>
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Cash */}
                <div className={`mt-10 bg-white p-3 rounded shadow-md ${ showCash ? '' : 'hidden' }`}>
                    <div className="flex gap-2 items-center justify-between">
                        <div className="flex gap-2 items-center">
                            <span className="font-semibold text-xl">Cash (Tunai)</span>
                            <button className="bg-black text-white px-2 py-2 rounded-md flex items-center gap-2"
                                onClick={() => {
                                    showLoading()

                                    try {
                                        fetchCustomerPaymentList(transactionDate, '2', '', '2').then((res) => {
                                            if (!res) return

                                            setCustomerPaymentListCash(res.data)
                                            setCustomerCash(res.data)
                                        })
                                    } finally {
                                        hideLoading()
                                    }
                                }}
                            >
                                <RevisionIcon className="w-6 fill-white" />
                            </button>
                        </div>
                        <div>
                            <button  
                                className="bg-black rounded-md text-white px-2 py-2"
                                onClick={() => setShowCash(!showCash)}
                            >
                                <XIcon className="w-6 fill-white" />
                            </button>
                        </div>                        
                    </div>

                    {/* Filter */}
                    <div>
                        <div className="mt-4">
                            <div className="flex gap-2">
                                <div className="w-72">
                                    <input 
                                        className="input" 
                                        value={cashCustomerNameFilter} 
                                        onChange={handleCashCustomerNameFilterChange} 
                                        placeholder="Customer Name" 
                                    />
                                </div>
                                <div className="w-72">
                                    <Dropdown className="w-full"
                                        value={cashLocationIdFilter} 
                                        options={cashLocationFilterOptions}
                                        onChange={handleCashLocationIdFilterChange}
                                        placeholder="All Location"
                                    />
                                </div>
                                <div className="w-48">
                                    <Dropdown className="w-full"
                                        value={cashStatusFilter} 
                                        options={DropdownStatusList}
                                        onChange={handleCashStatusFilterChange}
                                        placeholder="All Status"
                                    />
                                </div>
                                <button
                                    className="button"
                                    onClick={handleCashClearFilterClick}
                                >
                                    <span>Clear Filter</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Desktop version */}
                    <table className="w-full border bg-white mt-4 hidden sm:table">
                        <thead>
                            <tr className="h-12">
                                <th className="font-semibold w-16">No</th>
                                <th className="font-semibold text-left px-2 hidden sm:table-cell">Customer Name</th>
                                <th className="font-semibold text-left px-2">Amount</th>
                                <th className="font-semibold text-left px-2">Remark</th>
                                <th className="font-semibold text-left px-2">Location</th>
                                <th className="font-semibold text-left px-2 hidden sm:table-cell">Status</th>
                            </tr>
                        </thead>
                        <tbody className="border">
                            {customerPaymentListCash?.map((data, i) => {
                                return(
                                    <tr className="my-2 row h-10 border-y hover:bg-slate-300" key={ i }>
                                        <td className="text-center">{ i + 1 }</td>
                                        <td className="px-2">
                                            <span>{ data.customerName.toUpperCase() }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>Rp { money(data.amount) }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.remark }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.locationName.toUpperCase() }</span>
                                        </td>
                                        <td className="px-2 hidden sm:table-cell">
                                            <span>{ GetStatus(data.status) }</span>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                        <tfoot>
                            <tr className="h-12">
                                <th colSpan={2} className="font-semibold text-right px-2">Total</th>
                                <th className="font-semibold text-left px-2">Rp { money(customerPaymentListCash.reduce((total, item) => total + item.amount, 0)) }</th>
                                <th colSpan={6}></th>
                            </tr>
                        </tfoot>
                    </table>

                    {/* Mobile version */}
                    <div className="sm:hidden flex flex-col gap-2">
                        {customerPaymentListCash.length === 0 && 
                            <div className="my-2 h-10 border-y hover:bg-slate-300 flex items-center justify-center">
                                <span className="text-center">No Data Available</span>
                            </div>
                        }
                        {customerPaymentListCash.length > 0 && 
                            <div className="my-2 h-10 border-y hover:bg-slate-300 flex items-center justify-center">
                                <span className="font-semibold">Total : Rp { money(customerPaymentListCash.reduce((total, item) => total + item.amount, 0)) }</span>
                            </div>
                        }
                        {customerPaymentListCash?.map((data, i) => {
                            return(
                                <div className="border rounded-md p-2 flex flex-col">
                                    <div className="flex justify-between">
                                        <span className="text-sm font-semibold">{ data.customerName.toUpperCase() }</span>
                                        <span className="text-sm">Paid</span>
                                    </div>
                                    {/* <div className="flex justify-between">
                                        <span className="text-sm">{ data.bankName }</span>
                                        <span className="text-sm">{ data.accountNumber }</span>
                                    </div> */}
                                    <div className="flex justify-between">
                                        <span className="font-semibold text-sm">Rp { money(data.amount) }</span>
                                        <span className="text-sm">{ data.locationName.toUpperCase() }</span>
                                    </div>
                                    <div className={`${data.remark !== EmptyString ? 'flex' : 'hidden'}`}>
                                        <span className="text-sm">REMARK : { data.remark }</span>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>

                {/* Cash Button */}
                <div className={`bg-white shadow-md rounded flex justify-center items-center ${showCash ? '' : 'border-b'} p-2 cursor-pointer`}
                    onClick={() => { setShowCash(!showCash) }}
                >
                    { showCash ? <ChevronUpIcon className="w-8 h-8 fill-black" /> : <ChevronDownIcon className="w-8 h-8 fill-black" /> }
                    { showCash ? <span>Hide Cash (Tunai)</span> : <span>Show Cash (Tunai)</span> }
                </div>
                
                {/* Summary */}
                <div className={`mt-10 bg-white p-3 rounded shadow-md ${ showSummary ? '' : 'hidden' }`}>
                    <div className="flex gap-2 items-center justify-between">
                        <div className="flex gap-2 items-center">
                            <span className="font-semibold text-xl">Summary</span>
                            <button className="bg-black text-white px-2 py-2 rounded-md flex items-center gap-2"
                                onClick={() => {
                                    getCustomerPaymentSummary()
                                }}
                            >
                                <RevisionIcon className="w-6 fill-white" />
                            </button>
                        </div>
                        <div>
                            <button  
                                className="bg-black rounded-md text-white px-2 py-2"
                                onClick={() => setShowSummary(!showSummary)}
                            >
                                <XIcon className="w-6 fill-white" />
                            </button>
                        </div>                        
                    </div>
                    <div className="flex flex-col gap-2 mt-5">
                        <div className="flex ">
                            <div className="w-48">
                                <span className="text-sm sm:text-base">Total Transfer</span>
                            </div>
                            <div className="px-2">
                                <span className="text-sm sm:text-base">:</span>
                            </div>
                            <div>
                                <span className="text-sm sm:text-base">Rp { money(totalTransferAmount) }</span>
                            </div>
                        </div>

                        <div className="flex ">
                            <div className="w-48">
                                <span className="text-sm sm:text-base">Transfer Anjasmoro</span>
                            </div>
                            <div className="px-2">
                                <span className="text-sm sm:text-base">:</span>
                            </div>
                            <div>
                                <span className="text-sm sm:text-base">Rp { money(totalTransferAnjasmoro) }</span>
                            </div>
                        </div>

                        <div className="flex ">
                            <div className="w-48">
                                <span className="text-sm sm:text-base">Transfer Tlogosari</span>
                            </div>
                            <div className="px-2">
                                <span className="text-sm sm:text-base">:</span>
                            </div>
                            <div>
                                <span className="text-sm sm:text-base">Rp { money(totalTransferTlogosari) }</span>
                            </div>
                        </div>

                        <div className="mt-5 flex ">
                            <div className="w-48">
                                <span className="text-sm sm:text-base">Total Cash</span>
                            </div>
                            <div className="px-2">
                                <span className="text-sm sm:text-base">:</span>
                            </div>
                            <div>
                                <span className="text-sm sm:text-base">Rp { money(totalCashAmount) }</span>
                            </div>
                        </div>

                        <div className="flex ">
                            <div className="w-48">
                                <span className="text-sm sm:text-base">Cash Anjasmoro</span>
                            </div>
                            <div className="px-2">
                                <span className="text-sm sm:text-base">:</span>
                            </div>
                            <div>
                                <span className="text-sm sm:text-base">Rp { money(totalCashAnjasmoro) }</span>
                            </div>
                        </div>

                        <div className="flex ">
                            <div className="w-48">
                                <span className="text-sm sm:text-base">Cash Tlogosari</span>
                            </div>
                            <div className="px-2">
                                <span className="text-sm sm:text-base">:</span>
                            </div>
                            <div>
                                <span className="text-sm sm:text-base">Rp { money(totalCashTlogosari) }</span>
                            </div>
                        </div>

                        <div className="flex mt-5">
                            <div className="w-48">
                                <span className="text-sm sm:text-base">Total Cash In</span>
                            </div>
                            <div className="px-2">
                                <span className="text-sm sm:text-base">:</span>
                            </div>
                            <div>
                                <span className="text-sm sm:text-base">Rp { totalCashInAmount }</span>
                            </div>
                        </div>

                        <div className="flex ">
                            <div className="w-48">
                                <span className="text-sm sm:text-base">Total Transfer PL</span>
                            </div>
                            <div className="px-2">
                                <span className="text-sm sm:text-base">:</span>
                            </div>
                            <div>
                                <span className="text-sm sm:text-base">Rp { totalTransferPLAmount }</span>
                            </div>
                        </div>
                    </div>

                    <div className="mt-5">
                        <span className="font-semibold text-xl">Detail Transfer</span>
                        <hr />
                        <div>
                            {transferDetailList?.map((data, i) => {
                                return(
                                    <div>
                                        <div key={i} className="flex justify-between items-center py-3">
                                            <div>
                                                <span className="text-sm sm:text-base">{ String(data.transferSourceId) !== "0" ? (transferSourceOptions.find(opt => opt.value === String(data.transferSourceId)).label.length > 16 ? transferSourceOptions.find(opt => opt.value === String(data.transferSourceId)).label.slice(0, 16).toUpperCase() + "..." : transferSourceOptions.find(opt => opt.value === String(data.transferSourceId)).label.toUpperCase()) : "Unpaid Transfer" }</span>
                                            </div>
                                            <div>
                                                <span className="text-sm sm:text-base">Rp { money(String(data.amount)) }</span>
                                            </div>
                                        </div>
                                        <hr />
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>

                {/* Summary Button */}
                <div className={`bg-white shadow-md rounded flex justify-center items-center ${showSummary ? '' : ''} p-2 cursor-pointer`}
                    onClick={() => { setShowSummary(!showSummary) }}
                >
                    { showSummary ? <ChevronUpIcon className="w-8 h-8 fill-black" /> : <ChevronDownIcon className="w-8 h-8 fill-black" /> }
                    { showSummary ? <span>Hide Summary</span> : <span>Show Summary</span> }
                </div>
            </div>

            {isAdmin && (
                <div className={`mt-3`}>
                    <div>
                        <button className="button" onClick={() => { setShowBalance(!showBalance) }}>
                            <span>Show Balance</span>
                        </button>
                    </div>

                    {showBalance && (
                        <div className="mt-2">
                            <span className="text-xl font-semibold">Bank Balance</span>
                            <div className="my-2">
                                <input className="input" value={bankBalanceFilterAccountName} onChange={(e) => setBankBalanceFilterAccountName(e.target.value)} placeholder="Account Name" />
                            </div>
                            <div className="flex flex-wrap gap-2">
                                { balanceList
                                    ?.filter(item =>
                                    item.accountName
                                        ?.toLowerCase()
                                        .includes(bankBalanceFilterAccountName.toLowerCase())
                                    ).map((data, i) => {
                                    return (
                                        <div className="flex-1 bg-white rounded-lg shadow-md min-w-72 p-3">
                                            <div>
                                                <span className="text-sm">{ data.bankCode } - { data.accountName }</span>
                                            </div>
                                            <div>
                                                <span className="text-sm font-light">{ data.accountNo }</span>
                                            </div>
                                            <div className="">
                                                <span className="text-xl">Rp { money(data.balance) }</span>
                                            </div>
                                            <div className="flex gap-2 mt-2">
                                                <button className="px-2 rounded-full bg-black text-white text-xs"
                                                    onClick={() => {handleUpdateIncreaseBalance(data.transferSourceId, data.beneficiaryId, data.bankBalanceId, data.balance, 250000000)}}
                                                >
                                                    + 250 M
                                                </button>
                                                <button className="px-2 rounded-full bg-black text-white text-xs"
                                                    onClick={() => {handleUpdateDecreaseBalance(data.transferSourceId, data.beneficiaryId, data.bankBalanceId, data.balance, 250002500)}}
                                                >
                                                    - 250 M (BI FAST)
                                                </button>
                                                <button className="px-2 rounded-full bg-black text-white text-xs" 
                                                    onClick={() => { 
                                                        setSelectedBalance(data)
                                                        setIsEditBalanceModalOpen(true) 
                                                    }}
                                                >
                                                    Updt Bal
                                                </button>
                                            </div>
                                        </div>
                                    )
                                })}
                                
                            </div>
                        </div>
                    )}
                    
                </div>
            )}
            
            {isEditBalanceModalOpen && (
                <div
                    className="fixed inset-0 bg-black/50 flex items-center justify-center z-30"
                    onClick={() => setIsEditBalanceModalOpen(false)}
                >
                    <div
                        className="bg-white rounded-2xl shadow-lg p-6 w-[600px] relative"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2 className="text-xl font-semibold mb-2">{selectedBalance.bankCode} - {selectedBalance.accountName}</h2>
                        <p className="text-gray-600 mb-4">
                            Rp {money(selectedBalance.balance)}
                        </p>
                        <div className="flex gap-2">
                            <input className="input" value={onIncreaseBalance} onChange={(e) => {setOnIncreaseBalance(money(e.target.value))}} placeholder="Increase Value" />
                            <button className="button"
                                onClick={() => {handleUpdateIncreaseBalance(selectedBalance.transferSourceId, selectedBalance.beneficiaryId, selectedBalance.bankBalanceId, selectedBalance.balance, onIncreaseBalance)}}
                            >
                                Update
                            </button>
                        </div>

                        <div className="flex gap-2 mt-2">
                            <input className="input" value={onDecreaseBalance} onChange={(e) => {setOnDecreaseBalance(money(e.target.value))}} placeholder="Decrease Value" />
                            <button className="button"
                                onClick={() => {handleUpdateDecreaseBalance(selectedBalance.transferSourceId, selectedBalance.beneficiaryId, selectedBalance.bankBalanceId, selectedBalance.balance, onDecreaseBalance)}}
                            >
                                Update
                            </button>
                        </div>    

                        <div className="mt-5">
                            <button
                                onClick={() => setIsEditBalanceModalOpen(false)}
                                className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
                            >
                                Close
                            </button>
                        </div>
                        
                    </div>
                </div>
            )}

            {/* Modal */}
            {transferFormModal.isOpen && ( 
                <TransferFormModal 
                    onClose={transferFormModalClose} 
                    data={transferFormModal?.data} 
                    customerPaymentId={transferFormModal?.customerPaymentId} 
                    formType={transferFormModal?.formType} 
                /> 
            )}
        </MainBodyCard>
    )
}